class DigitalNatureCarouselSlideComponent extends HTMLElement
{
    constructor() {
        super();
    }
}

// add the custom element to the registry
customElements.define('digital-nature-carousel-slide', DigitalNatureCarouselSlideComponent);